import { AxiosError, AxiosPromise } from 'axios'
import { useCallback, useState } from 'react'

interface IUseApiResults<T> {
  loading: boolean
  data?: T
  error?: AxiosError
  requestCount: number
}

// Note: If your `promise` param changes on every render (for example, if you're passing an anonymous function into this),
// then `refresh` will change on every render too.
export default function useAPI<T>(
  promise: (...args: any) => AxiosPromise<T>
): [IUseApiResults<T>, (...args: any) => void] {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<any>(undefined)
  const [error, setError] = useState<AxiosError>(undefined)
  const [requestCount, setRequestCount] = useState(0)

  const refresh = useCallback(
    async (...args) => {
      setLoading(true)
      setError(undefined)
      try {
        const res = await promise(...args)
        setData(res.data)
      } catch (e) {
        setError(e)
      } finally {
        setRequestCount(current => current + 1)
        setLoading(false)
      }
    },
    [promise]
  )

  return [{ loading, data, error, requestCount }, refresh]
}
